import './composables/router'
import { authModule } from '@/store'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import axios from './plugins/axios'
import './plugins/tanstack'
import AppLoading from './components/ui/AppLoading.vue'

// @ts-ignore
import { Plugin } from 'vue-fragment'
import { application } from '@/store'
import './plugins/dayjs'
import { vMaska } from 'maska/vue';
import { auth } from '@/firebase'

Vue.use(Plugin)

Vue.config.productionTip = false

Vue.component('AppLoading', AppLoading)

Vue.directive('maska', vMaska)

// OneSignal desativado
// const isLocalHost = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
//
// window.OneSignal = window.OneSignal || []
// window.OneSignal.push(() => {
// 	window.OneSignal.init({
// 		appId: isLocalHost
// 			? '4a798cb0-0af5-4fcf-acdd-bcc668f44fbc'
// 			: 'f71983ea-78b4-4f41-8530-6e8ad5199763',
// 		allowLocalhostAsSecureOrigin: true,
// 	})
// })

new Vue({
	router,
	pinia,
	// @ts-ignore
	axios,
	vuetify,
	created() {
		if (authModule.isAuth) {
			auth.signInAnonymously()
			application.inicializarAtualizacaoDeContexto()
		}
	},
	render: (h) => h(App),
}).$mount('#app')
